// Libs
import React from "react";
import { useObserver } from "@shoothill/core";
import styled from "styled-components";
import { Box, Typography, Divider } from "@material-ui/core";

// App
import PaymentViewModel from "Globals/ViewModels/Payment/PaymentViewModel";
import DashboardViewModel from "Globals/ViewModels/Dashboard/DashboardViewModel";
import { Application } from "./Application";
import { theme } from "Globals/Styles/AppTheme";
import { StoresInstance } from "Globals/Stores";

export const ApplicationsContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
    > div {
        margin-bottom: 30px;
    }
    > *:not(:last-child) {
        display: block;
        margin-right: 30px;
    }
`;

interface IProps {
    paymentViewModel: PaymentViewModel;
    viewModel: DashboardViewModel;
}

export const Applications: React.FC<IProps> = (props: IProps) => {
    const applications = () => (
        <>
            <Typography color={"inherit"} variant={"h6"} style={{ fontWeight: "bold", marginBottom: "15px" }}>
                Applications
            </Typography>
            <ApplicationsContainer>
                {props.viewModel.submittedApplications.map((application, index) => (
                    <Application key={`${application.model.id}-${index}`} paymentViewModel={props.paymentViewModel} viewModel={application} index={index} />
                ))}
            </ApplicationsContainer>
            <Divider />
            <Typography color={"inherit"} variant={"h6"} style={{ fontWeight: "bold", marginBottom: "15px" }}>
                Unfinished applications
            </Typography>
            <ApplicationsContainer>
                {props.viewModel.notSubmittedApplications.map((application, index) => (
                    <Application key={`${application.model.id}-${index}`} paymentViewModel={props.paymentViewModel} viewModel={application} index={index} />
                ))}
            </ApplicationsContainer>
        </>
    );

    return useObserver(() => <>{applications()}</>);
};
